import React, { useState, useEffect, useCallback } from 'react';
import { FiWifiOff } from 'react-icons/fi';

const HERE_API_KEY = process.env.REACT_APP_HERE_MAPS_API_KEY;

const StaticsMapsRecorrido2 = ({ recorrido, ultRecorrido }) => {
  const [mapRecorrido, setMapRecorrido] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState(null);
  const [mapKey, setMapKey] = useState(0);
  const [noCoordenadas, setNoCoordenadas] = useState(false);

  useEffect(() => {
    setLoading(true);
    setMapRecorrido(recorrido);
    // console.log("📌 Recorrido actualizado:", recorrido);
    console.log("📌 Recorrido actualizado:", recorrido);
  }, [recorrido]);

  // Función para simplificar el path y reducir la cantidad de puntos
  const simplifyPath = (path, maxPoints = 50) => {
    if (path.length <= maxPoints) return path;
    const step = Math.ceil(path.length / maxPoints);
    return path.filter((_, index) => index % step === 0);
  };

  // Función para calcular el centro del recorrido
  const calculateCenter = (path) => {
    const latitudes = path.map(point => point.Latitud);
    const longitudes = path.map(point => point.Longitud);

    return {
      lat: (Math.max(...latitudes) + Math.min(...latitudes)) / 2,
      lng: (Math.max(...longitudes) + Math.min(...longitudes)) / 2,
    };
  };

  // Función para calcular el zoom dinámico en función de la distancia entre los puntos
  // const calculateZoom = (path) => {
  //   const latitudes = path.map(point => point.Latitud);
  //   const longitudes = path.map(point => point.Longitud);

  //   const latDiff = Math.max(...latitudes) - Math.min(...latitudes);
  //   const lngDiff = Math.max(...longitudes) - Math.min(...longitudes);

  //   const maxDiff = Math.max(latDiff, lngDiff);
  //   console.log("🔍 Diferencia máxima entre puntos:", maxDiff);

  //   if (maxDiff > 10) return 7;
  //   if (maxDiff > 5) return 5.8;
  //   if (maxDiff > 3) return 7;
  //   if (maxDiff > 1) return 8;
  //   if (maxDiff > 0) return 10;
  //   return 10; // Zoom más cercano si los puntos están muy cerca
  // };
  // Zoom usando SOLO inicio y fin (rápido y simple)
  const calculateZoom = (path) => {
    if (!Array.isArray(path) || path.length < 2) return 12;

    const a = path[0];
    const b = path[path.length - 1];

    // Soporta Latitud/Longitud o latitude/longitude
    const lat1 = Number(a.Latitud ?? a.latitude);
    const lon1 = Number(a.Longitud ?? a.longitude);
    const lat2 = Number(b.Latitud ?? b.latitude);
    const lon2 = Number(b.Longitud ?? b.longitude);

    if (![lat1, lon1, lat2, lon2].every(Number.isFinite)) return 12;

    // Span máximo en grados (aprox de tamaño del recorrido)
    const span = Math.max(Math.abs(lat2 - lat1), Math.abs(lon2 - lon1));
    console.log("🔍 Span del recorrido:", span);
    // span ~ 0.01 ≈ 1.1 km, 0.1 ≈ 11 km, 1 ≈ 111 km

    // 💣 Defensa: si el span es ridículamente grande, asumimos datos malos
    if (span > 90) {
      console.warn("⚠️ Span anómalo, usando zoom de respaldo", {
        span,
        from: a,
        to: b,
      });
      // Zoom “decente” para que al menos se vea el país/región
      return 2;
    }

    let z;
    if (span > 20) z = 3.5;        // grandes departamentos o provincias
    else if (span > 10) z = 5;     // zonas metropolitanas amplias
    else if (span > 7) z = 5.5;    // zonas metropolitanas amplias
    else if (span > 5) z = 6;      // misma ciudad extendida
    else if (span > 3) z = 6;      // misma ciudad extendida
    else if (span > 2) z = 7;      // ciudad completa
    else if (span > 1) z = 8.5;    // ciudad completa
    else if (span > 0.91) z = 8.5; // ciudad completa
    else if (span > 0.5) z = 9;    // barrio grande o zona rural
    else if (span > 0.3) z = 9.5;  // 10–20 km
    else if (span > 0.2) z = 10;   // 10–20 km
    else if (span > 0.1) z = 11;   // 10–20 km
    else if (span > 0.08) z = 12;  // 3–5 km
    else if (span > 0.05) z = 12;  // 3–5 km
    else if (span > 0.04) z = 12.5;// 3–5 km
    else if (span > 0.01) z = 13;  // 1–2 km
    else if (span > 0.008) z = 10; // 1–2 km (ojo: aquí tuviste este valor)
    else if (span > 0.005) z = 14.5; // pocas cuadras
    else z = 16;                  // muy cerca

    // HERE cómodo ~ [3..17]
    return Math.min(17, Math.max(3, z));
  };



  const updateImage = useCallback((path) => {
    console.log("Actualizando imagen del mapa con path:", path);
    if (!path.length) return;

    setLoading(true);

    try {
      const filteredPath = path.filter(punto => punto.Latitud !== 0 && punto.Longitud !== 0);
      if (filteredPath.length < 2) {
        console.error("No hay suficientes puntos para trazar una línea.");
        setLoading(false);
        return;
      }

      // console.log("HERE API KEY:", HERE_API_KEY);
      if (!HERE_API_KEY) {
        console.error("HERE API KEY no está definida. Verifica tu .env");
        return;
      }

      // Reducimos los puntos antes de enviarlos a HERE
      // const simplifiedPath = simplifyPath(filteredPath, 50);

      // Calculamos el centro y el zoom dinámico
      const { lat, lng } = calculateCenter(path);
      const zoom = calculateZoom(path);
      // console.log("📍 Centro del recorrido:", lat, lng);
      // console.log("🔍 Zoom dinámico:", zoom);

      // Generamos `geojson=` para HERE
      const geojsonLine = encodeURIComponent(
        JSON.stringify({
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              properties: {
                color: "#0000FFFF",
                width: "6",
                "outline-color": "#000000FF",
                "outline-width": "0px",
              },
              geometry: {
                type: "LineString",
                coordinates: path.map(point => [point.Longitud, point.Latitud]), // HERE usa LONG, LAT
              },
            },
          ],
        })
      );

      // console.log("📌 GeoJSON para HERE (puntos reducidos):", JSON.parse(decodeURIComponent(geojsonLine)));

      // Generar la URL de HERE Maps con `geojson=`
      const newImageUrl = `https://image.maps.hereapi.com/mia/v3/base/mc/center:${lat},${lng};zoom=${zoom}/330x330/png8?apikey=${HERE_API_KEY}&style=explore.day&geojson=${geojsonLine}`;




      setTimeout(() => {
        setImageUrl(newImageUrl);
        setMapKey(prevKey => prevKey + 1);
        setLoading(false);
      }, 1000);
    } catch (err) {
      console.error("❌ Error al actualizar la imagen del mapa:", err);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (mapRecorrido.length > 0) {
      updateImage(mapRecorrido);
      setNoCoordenadas(false);
    }
    if (mapRecorrido.length === 0) {
      setNoCoordenadas(true);
      setLoading(false);
    }
  }, [mapRecorrido, updateImage]);

  return (
    <div
      style={{
        height: "330px",
        width: "100%",
        backgroundColor: "#f3f4f6", // gris claro
      }}
      className="imgUltimoRecorrido"
    >
      {noCoordenadas ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "#6b7280",
          }}
        >
          <FiWifiOff size={55} style={{ marginBottom: "8px" }} />
          <p style={{ margin: 0, fontWeight: 500 }}>
            No hay coordenadas disponibles para mostrar en el mapa.
          </p>
          <small>Problemas de conexión o sin rastreo activo</small>
        </div>
      ) : (
        <>
          {loading ? (
            <div
              style={{
                position: "relative",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transform: 'translateY(150px)'
              }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only"
                  style={{
                    display: 'flex',
                    alignItems: "center",
                    justifyContent: "center"
                  }}>Loading...</span>
              </div>
            </div>
          ) : (

            <>
              <img
                key={mapKey}
                src={imageUrl}
                onLoad={() => setLoading(false)}
                onError={() => {
                  setLoading(false);
                  console.error("❌ Error cargando la imagen del mapa");
                }}
                style={{
                  display: loading ? "none" : "block",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                alt="Mapa del recorrido"
              />
            </>
          )}
        </>
      )}
    </div>

  );
};

export default StaticsMapsRecorrido2;
